module.exports = __webpack_public_path__ + "static/img/icon2.2c4de196.png";